import { render, staticRenderFns } from "./labList.vue?vue&type=template&id=0542c9ae&scoped=true&"
import script from "./labList.vue?vue&type=script&lang=js&"
export * from "./labList.vue?vue&type=script&lang=js&"
import style0 from "./labList.vue?vue&type=style&index=0&id=0542c9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542c9ae",
  null
  
)

export default component.exports